import { Assert } from "@seriously-rad/seriouslyrad-framework-core/Assert";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { IJNativeEvent } from "@seriously-rad/seriouslyrad-framework-core/JNative";
import { PropertyChange } from "@seriously-rad/seriouslyrad-framework-core/PropertyChange";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { IInputControl, InputControl, InputControlPropertyValues } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/InputControl";
import { TextBox } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/TextBox";
import { NAMESPACE } from "./_Namespace";

export type RuntimeProcessPropertyInputPropertyValues =
    InputControlPropertyValues
    & {
    };

export type RuntimeProcessPropertyInputProperties = {
    [name in keyof RuntimeProcessPropertyInputPropertyValues]: Property<RuntimeProcessPropertyInputPropertyValues[name]>
};

export interface IRuntimeProcessPropertyInput extends IInputControl, RuntimeProcessPropertyInputProperties
{
}

export class RuntimeProcessPropertyInput extends InputControl implements IRuntimeProcessPropertyInput
{
    // #region Static

    public static override classNamespace = NAMESPACE + "RuntimeProcessPropertyInput";
    public static override className = "RuntimeProcessPropertyInput";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<RuntimeProcessPropertyInputPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Global Variables

    protected __textBoxValueChanging?: boolean;
    protected textBox?: TextBox;

    // #endregion

    // #region Constructor

    constructor(propertyValues?: PartialNullable<RuntimeProcessPropertyInputPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override _bindEvents()
    {
        super._bindEvents();

        Assert.isNotNullOrUndefined(this.textBox, "this.textBox");

        this.textBox.on("valueChanged", { self: this }, this.onTextBoxValueChanged);
    }
    protected override _createElement()
    {
        const
            $$element = super._createElement();

        this.textBox =
            new TextBox({ dataSourcePropertyType: "System.String, System.Private.CoreLib" })
                .appendTo($$element);

        return $$element;
    }
    protected override _createElementComplete()
    {
        super._createElementComplete();

        this.addCssClass("rad-control-runtime-process-property-input");
    }
    protected override _refreshFromDataSource()
    {
        Assert.isNotNullOrUndefined(this.textBox, "this.textBox");

        const
            dataSource = this.dataSource.get(),
            dataSourceProperty = this.dataSourceProperty.get();

        if (dataSource && dataSourceProperty)
        {
            const
                dataSourcePropertyValue = dataSource && dataSourceProperty ? dataSource.propertyValueByPathGet(dataSourceProperty) : null;

            if (!dataSourcePropertyValue)
            {
                dataSource.propertyValueByPathSet(dataSourceProperty, {
                    path: null
                });
            }

            if (!this.__textBoxValueChanging)
                this.textBox.value.set(dataSource.propertyValueByPathGet(dataSourceProperty + ".path"));

            return;
        }

        if (!this.__textBoxValueChanging)
            this.textBox.value.set(null);
    }

    // #endregion

    // #region Event Handlers

    protected onTextBoxValueChanged(evt: IJNativeEvent, change: PropertyChange<any>)
    {
        const
            self = evt.data.self as this;

        self.__textBoxValueChanging = true;

        const
            dataSource = self.dataSource.get(),
            dataSourceProperty = self.dataSourceProperty.get();

        if (dataSource && dataSourceProperty)
        {
            dataSource.propertyValueByPathSet(dataSourceProperty, {
                path: change.currentValue
            });
        }

        self.__textBoxValueChanging = false;
    }

    // #endregion

    // #endregion
}

